import { observer } from 'mobx-react-lite';
import PreselectedEMDesign3 from './designs/PreselectedEMDesign3';

export const PageState = {
  ENTRY_METHOD_SELECTION: 0,
  AUTHENTICATION: 1,
  ADD_ON_AND_PROMO: 2,
  PAYING: 3,
};

const PageContent = observer(() => {
  // Called once the user confirms their numbers.
  // `overrideDefaultAuthenticationFormView` affects whether to navigate to log-in/register/guest form.

  return (
    <div className="pageContent fullWidth flexCentered">
      <PreselectedEMDesign3 />
    </div>
  );
});

export default PageContent;
